import React from 'react'
import heroImage from './../assets/images/heroImage3.webp'
import CustomCard from '../shared/customCard/CustomCard'
import './airportStations.scss'
import CustomButton from '../shared/customButton/CustomButton'
import { setSelectedSearchBoxTab } from '../redux/actions/homeActions'
import { useHistory } from 'react-router'
import { useAppDispatch } from '../redux/hooks'
import { Helmet } from 'react-helmet-async'

const questions = [
  {
    table: (
      <div className="table-container-aiportstations">
        <div>
          <table className="table">
            <thead>
              <tr>
                <th>Airport Station</th>
                <th>Closest City Train Station</th>
                <th>Journey Time</th>
                <th>Train</th>
                <th>Frequency</th>
                <th>Links to other destinations</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>London Heathrow Airport</td>
                <td>London Paddington</td>
                <td>
                  15-21 minutes <br></br>35 minutes
                </td>
                <td>
                  Heathrow Express <br></br> Tfl Rail (previously Heathrow
                  Connect)
                </td>
                <td>
                  Trains every 15 minutes from 05:00 - 23:30 <br></br> Trains
                  every 15 - 30 minutes from 05:30 - 23:30
                </td>
                <td>
                  From London Paddington Station, you can travel directly to the
                  South West of England to Oxford, Reading, Bath Spa, Bristol,
                  Plymouth or explore South Wales to Cardiff and Swansea. You
                  can also take the London Underground and explore centrally
                  within London or connect onto other London Stations for trains
                  departing to other UK cities.{' '}
                </td>
              </tr>
              <tr>
                <td>London Gatwick Airport</td>
                <td>
                  London Victoria <br></br>London Victoria<br></br> London St
                  Pancras
                </td>
                <td>30 minutes</td>
                <td>
                  Gatwick Express<br></br>Southern<br></br>Thameslink
                </td>
                <td>
                  Trains every 30 minutes from 05:30 - 23:00 <br></br> Trains
                  every 15 - 30 minutes from 05:30 - 23:55<br></br> Trains every
                  60 minutes from 00:00 - 04:00<br></br>Trains every 10-20
                  minutes from 04:00 - 23:30
                </td>
                <td>
                  From Gatwick Airport Station, as well as trains into London
                  Victoria or London St Pancras, you can travel directly to
                  other towns and cities like Peterborugh, Brighton, Reading or
                  Portsmouth. London Victora & London St Pancras offer links on
                  the London Underground and to destinations all over the UK.{' '}
                </td>
              </tr>
              <tr>
                <td>London Luton Parkway</td>
                <td>London St Pancras</td>
                <td>20 - 50 minutes</td>
                <td>Thameslink & East Midlands</td>
                <td>
                  Trains every 30 minutes from 00:00 - 05:00 <br></br>Trains
                  every 10-minutes from 05:00 - 23:30{' '}
                </td>
                <td>
                  From Luton Airport, frequent trains are available to take you
                  into London St Pancras where you can link onto other Central
                  London stations via the London Underground, or travel directly
                  from Luton Airport onto Brighton, Gatwick, Leciester, Ashford
                  International and Dover.{' '}
                </td>
              </tr>
              <tr>
                <td>London Stansted Airport</td>
                <td>London Liverpool St</td>
                <td>45 minutes</td>
                <td>Stansted Express</td>
                <td>
                  Trains every 15 minutes during the day from 4am to 00:00
                </td>
                <td>
                  From Stansted Airport, you can travel directly into London
                  Liverpool St or to other UK cities like Birmingham, Cambridge,
                  Leicester and Norwich.
                </td>
              </tr>
              <tr>
                <td>London Southend Airport</td>
                <td>London Liverpool St</td>
                <td>56 minutes</td>
                <td>Greater Anglia</td>
                <td>Trains every 15-30 minutes from 04:00 - 00:00</td>
                <td>
                  From London Liverpool St Station, you can use the London
                  Underground to travel to other Central London Stations and
                  connect to services departing to other major UK towns and
                  Cities.{' '}
                </td>
              </tr>
              <tr>
                <td>Birmingham International</td>
                <td>Birmingham New Street</td>
                <td>10-20 minutes</td>
                <td> </td>
                <td>Trains every 15-30 minutes from 05:50 - 23:45 </td>
                <td>
                  Birmingham Airport offers a free Air-Link monorail which run
                  every few minutes to take passengers to Birmingham
                  International Station. From here, direct trains are available
                  into Birmingham or further afield to London, Manchester,
                  Edinburgh, Aberystwyth, The Lake District or Bournemouth.{' '}
                </td>
              </tr>
              <tr>
                <td> Manchester Airport</td>
                <td>Manchester Piccadiilly</td>
                <td>20 minutes</td>
                <td>TransPennine Express & Northern Rail</td>
                <td>Trains every 15-30 minutes from 05:00 - 00:00</td>
                <td>
                  From Manchester Airport, as well as travelling into Manchester
                  Piccaddilly, trains can be booked directly to York, Leeds,
                  Winderemere, Edinburgh or Holyhead. Trains from Manchester
                  Piccaddilly can take you to other UK cities like London or
                  Liverpool.{' '}
                </td>
              </tr>
              <tr>
                <td> Rhoose Cardiff International Airport</td>
                <td>Cardiff Central</td>
                <td>35 minutes</td>
                <td>Transport for Wales </td>
                <td>Trains every 60 minutes from 07:00 - 23:00 </td>
                <td>
                  From Rhoose Cardiff Station, trains can take you directly into
                  Cardiff Central or nearby towns in South Wales; Bridgend,
                  Abadare or Pontypridd. Cardiff Central links to other UK towns
                  and cities such as Swansea, Bristol, Shrewsbury, Manchester,
                  London and Holyhead.{' '}
                </td>
              </tr>
              <tr>
                <td>Southampton Airport Parkway</td>
                <td>Southampton Central </td>
                <td>7 minutes</td>
                <td>South Western Railway & CrossCountry </td>
                <td>Trains every 15-30 minutes from 06:00 - 23:00 </td>
                <td>
                  Southampton Airport offers quick services into Southampton
                  Central, or direct trains to London, Reading, Portsmouth and
                  Bournemouth.{' '}
                </td>
              </tr>
              <tr>
                <td>Albany International Airport, NY</td>
                <td>Albany-Rennsselaer, NY</td>
                <td>40 minutes</td>
                <td>Thruway Bus </td>
                <td>Bus departs twice daily at 12:20 & 19:15 </td>
                <td>
                  From Albany, direct services are available to link you to
                  popular desinations in the North East such as New York,
                  Montreal, Buffalo, Boston or Washington.
                </td>
              </tr>
              <tr>
                <td>Burbank Airport, CA</td>
                <td>Burbank, CA</td>
                <td>4 minutes</td>
                <td>Pacific Surfliner</td>
                <td>Train departs twice daily at 09:17 & 16:21 </td>
                <td>
                  From Burbank, direct services are available to link you to
                  other destinations along the Californian Coast such as Los
                  Angeles, Santa Barbara, San Diego or San Jose.{' '}
                </td>
              </tr>
              <tr>
                <td>BWI Thurgood Marshall Airport, MD</td>
                <td>Baltimore (Penn Station), MD</td>
                <td>11-14 minutes</td>
                <td>Northeast Regional & Acela</td>
                <td>Trains every hour from 06:00 - 22:30 </td>
                <td>
                  Free shuttle buses run from the Airport to the Airport Station
                  every 25 minutes. From Balitmore, direct services are
                  available to link you to popular destinations in the North
                  East such as Washington, Philadelphia, New York or Boston.{' '}
                </td>
              </tr>
              <tr>
                <td>Milwaukee Airport (Trains), WI</td>
                <td>Milwaukee (Downtown), WI</td>
                <td>15 minutes</td>
                <td>Hiawatha Service</td>
                <td>Trains every 2-3 hours from 07:00 - 21:00 </td>
                <td>
                  From Milwaukee, direct services are available to link to your
                  destinations all across the Midwest including Chicago,
                  Minneapolis, Kansas City & St Louis
                </td>
              </tr>
              <tr>
                <td>Medford Airport, OR</td>
                <td>Klamath Falls, OR</td>
                <td>1 hour 40 minutes</td>
                <td>Thruway Bus </td>
                <td>Bus departs at 17:50 </td>
                <td>
                  From Klamath Falls, direct services are available to link you
                  to destinations in the Pacifici North West region to cities
                  such as Portland, Seattle, Eugene-Springfield & Vancouver.{' '}
                </td>
              </tr>
              <tr>
                <td>Newark Liberty International Airport, NJ</td>
                <td>Newark (Penn Station), NJ</td>
                <td>5 minutes</td>
                <td>Northeast Regional </td>
                <td>Trains every 2-3 hours from 10:00 - 21:00</td>
                <td>
                  From Newark, direct services are available to link you to
                  popular desinations in the North East such as New York,
                  Boston, Washington, Philadelphia or Balitmore.{' '}
                </td>
              </tr>
              <tr>
                <td>Syracuse Airport, NY</td>
                <td>Syracuse (Transportational Centre), NY</td>
                <td>10-15 minutes</td>
                <td>Thruway Bus</td>
                <td>Bus departs twice daily at 10:40 & 16:10 </td>
                <td>
                  From Syracuse, direct services are available to link you to
                  popular desinations in the North East such as New York,
                  Boston, Cleveland or Washington.{' '}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
]
const questionsBus = [
  {
    tableBus: (
      <div className="table-container-aiportstations">
        <CustomCard>
          <table className="table">
            <thead></thead>
            <tbody>
              <tr>
                <td>Bristol Airport (By Bus)</td>
                <td>Bristol Temple Meads</td>
              </tr>
              <tr>
                <td>East Midlands Airport(By Bus)</td>
                <td>
                  Nottingham <br></br>Leicester<br></br>Derby
                </td>
              </tr>
              <tr>
                <td>Edinburgh Airport (By Bus or Train)</td>
                <td>Edinburgh Gateway</td>
              </tr>
              <tr>
                <td>Newcastle Airport</td>
                <td>Newcastle Central</td>
              </tr>
            </tbody>
          </table>
        </CustomCard>
      </div>
    ),
  },
]

function AirportStations() {
  const history = useHistory()
  const dispatch = useAppDispatch()
  return (
    <>
      <Helmet>
        <title>
          Rail Online - Buy Cheap Train Tickets in UK & Europe Online
        </title>
        <meta
          name="description"
          content="Rail Online is a quick & easy way to book cheap train tickets across UK & Europe. Take the scenic route with terrific deals on train tickets."
        />
        <link rel="canonical" href="https://www.rail.online/airport-stations" />
      </Helmet>
      <div className="hero-image-container">
        <div className="background-shade d-none d-md-flex opacity-change"></div>
        <img
          className="img-fluid hero-image d-none d-md-flex"
          src={heroImage}
          alt="heroImage"
          loading='lazy'
        />
        <div className="about-us-page--title">
          <h1>Airport Stations</h1>
        </div>
      </div>
      <div className="container-fluid max-width mb-5">
        <div className="common-page">
          <div className="common-page--content-area max-width about-us-page">
            <h3 className="mt-5 mb-3 text-left">
              {' '}
              UK and US Airport Train Transfers
            </h3>
            <div className="row">
              <div className="col-sm-12">
                <div className="content-container">
                  <div className="table-container">
                    <CustomCard className="airport-table--card">
                      {questions.map(({ table }) => (
                        <div className="qa-box">
                          <div className="text-align left">
                            {table}
                          </div>
                        </div>
                      ))}
                    </CustomCard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid max-width mb-5">
        <div className="common-page">
          <div className="common-page--content-area max-width about-us-page">
            <h3 className="mt-5 mb-3 text-left">
              Below are by bus / metro from Airport City Center for addtional
              information
            </h3>
            {questionsBus.map(({ tableBus }) => (
              <div className="qa-box">
                <div className="p-2 p-md-3 text-align left">{tableBus}</div>
              </div>
            ))}
            <h3 className="mt-5 mb-4">Ready to save on train tickets?</h3>
            <div className="d-flex w-100 justify-content-center">
              <CustomButton
                text="BOOK A TRIP"
                className="go-btn"
                onClick={() => {
                  dispatch(setSelectedSearchBoxTab('Train Tickets'))
                  history.push('/')
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AirportStations
